import { axios, handleError } from '../axios';

export const memberAllEventSeen = () => {
  return new Promise((resolve, reject) => {
    axios
      .post('member/events/seen')
      .then((response) => {
        try {
          resolve(response.data);
        } catch (e) {
          console.error(e.message);
        }
      })
      .catch((e) => {
        handleError(e);
      });
  });
};
